import React, { useState } from 'react';
import { gql } from '@soundxyz/gql-string';
import { GetNotifiedButton } from '@components/EmailNotifications/GetNotifiedButton';
import { CopyLinkMenuItem } from '@components/basics/Dropdowns/MenuItems/CopyLinkMenuItem';
import { EditArtistPickMenuItem } from '@components/basics/Dropdowns/MenuItems/EditArtistPickMenuItem';
import { ThreeDotsDropdown } from '@components/basics/Dropdowns/ThreeDotsDropdown';
import { EditArtistPickModal } from '@components/modals/EditArtistPickModal';
import { useAuth } from '@context/auth/base';
import { ModalContext, ModalType } from '@context/modal';
import type { FragmentType } from '@graphql/reactQuery';
import { ArtistActionBarFragmentDoc, getFragment } from '@graphql/reactQuery';
import { FollowEdit } from './FollowEdit';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ArtistActionBar on User {
    id
    webappUri
    artist {
      id
      bannerImage {
        id
        url
      }
      pickedRelease {
        id
      }
      numReleases(filter: { releaseAuthor: ALL })
    }
  }

  mutation uploadArtistBannerImage($bannerImage: UploadedMedia!) {
    upsertArtistBannerImage(bannerImage: $bannerImage) {
      id
      bannerImage {
        id
        url
        key
      }
    }
  }
`);

export const ArtistActionBar = ({
  actionBarData,
}: {
  actionBarData: FragmentType<ArtistActionBarFragmentDoc>;
}) => {
  const { authUser } = useAuth();
  const { openModal } = ModalContext.useContainer();
  const { id, webappUri, artist } = getFragment(ArtistActionBarFragmentDoc, actionBarData);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const artistPickReleaseId = artist?.pickedRelease?.id;

  const isOwner = authUser?.id === id;

  const showArtistPickMenuItem = isOwner && artist && !!artist?.numReleases;

  return (
    <div className="flex items-center gap-2">
      <ThreeDotsDropdown isDropdownOpen={isDropdownOpen} setIsDropdownOpen={setIsDropdownOpen}>
        <CopyLinkMenuItem url={webappUri} />
        {showArtistPickMenuItem && (
          <EditArtistPickMenuItem
            label="Edit Artist Pick"
            onClick={() =>
              openModal(ModalType.EDIT_FEATURED_SOUND, {
                body: (
                  <EditArtistPickModal
                    artistId={artist?.id}
                    artistPickReleaseId={artistPickReleaseId}
                  />
                ),
              })
            }
          />
        )}
      </ThreeDotsDropdown>
      {!isOwner && !!artist && (
        <GetNotifiedButton type="new_profile_action_bar" artistId={artist.id} userId={id} />
      )}
      <FollowEdit userId={id} artistId={artist?.id} owner={isOwner} />
    </div>
  );
};
